export default "__VITE_ASSET__DcmQjtql__"